/**
 *
 * Asynchronously loads the component for Importazione
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Importazione/Loadable.js